document.addEventListener('DOMContentLoaded', () => {
  const trix = document.querySelector('.trix-button-row');
  if (trix) {
    document.addEventListener('trix-initialize', () => {
      const fileUploadButton = document.querySelector('.trix-button-group--file-tools');
      fileUploadButton.remove();
    });
  }
});
